var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrCalendar = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#374957",
    clipPath: "url(#" + _uid + "fi-rr-calendar_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2h-1V1a1 1 0 0 0-2 0v1H8V1a1 1 0 0 0-2 0v1H5a5.006 5.006 0 0 0-5 5v12a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5V7a5.006 5.006 0 0 0-5-5M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v1H2zm17 15H5a3 3 0 0 1-3-3v-9h20v9a3 3 0 0 1-3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M7 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "fi-rr-calendar_svg__a"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgFiRrCalendar as ReactComponent };
export default __webpack_public_path__ + "0e1021641b0e0b4a4dc0540f7b723698.svg";